import api from './api';

export interface Notification {
    id: string;
    type: string;
    title: string;
    message: string;
    data?: Record<string, any>;
    read: boolean;
    readAt?: string;
    createdAt: string;
}

export interface NotificationListResponse {
    notifications: Notification[];
    pagination: {
        page: number;
        limit: number;
        total: number;
        pages: number;
    };
}

class NotificationService {
    private baseUrl = '/api/notifications';

    /**
     * Get user notifications with pagination
     */
    async getNotifications(page = 1, limit = 20): Promise<NotificationListResponse> {
        return api.get<NotificationListResponse>(`${this.baseUrl}?page=${page}&limit=${limit}`);
    }

    /**
     * Get unread notification count
     */
    async getUnreadCount(): Promise<{ count: number }> {
        return api.get<{ count: number }>(`${this.baseUrl}/unread-count`);
    }

    /**
     * Mark a single notification as read
     */
    async markAsRead(notificationId: string): Promise<void> {
        await api.patch(`${this.baseUrl}/${notificationId}/read`);
    }

    /**
     * Mark all notifications as read
     */
    async markAllAsRead(): Promise<{ success: boolean; count: number }> {
        return api.post<{ success: boolean; count: number }>(`${this.baseUrl}/read-all`);
    }
}

export const notificationService = new NotificationService();
export default notificationService;
